import { useState } from "react";
import PropTypes from "prop-types";
import { Outlet } from "react-router-dom";
import { experimentalStyled } from "@material-ui/core/styles";
// import Footer from "./Footer";
import MainNavbar from "./MainNavbar";
import MainSidebar from "./MainSidebar";
import { Box } from "@material-ui/core";


const MainLayoutRoot = experimentalStyled("div")(({ theme }) => ({
  backgroundColor: {
    xs: theme.palette.background.xs,
    md: theme.palette.background.default,
  },
  height: "100%",
  paddingTop: 64,
}));

const MainLayout = ({ children }) => {
  const [isSidebarMobileOpen, setIsSidebarMobileOpen] = useState(false);

  return (
    <MainLayoutRoot>
      <MainNavbar onSidebarMobileOpen={() => setIsSidebarMobileOpen(true)} />
      <MainSidebar
        onMobileClose={() => setIsSidebarMobileOpen(false)}
        openMobile={isSidebarMobileOpen}
      />
      <Box
        sx={{
          backgroundColor: {
            md: "background.default",
            xs: "background.xs",
          },
          // height: "100%",
          minHeight: "calc(100vh - 106px)",
        }}
      >
        {children || <Outlet />}
      </Box>
      {/* <Footer /> */}
    </MainLayoutRoot>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node,
};

export default MainLayout;
